import api from './api';

// Company-facing credits
export const getAiCredits = () => api.get('/ai/credits');
export const requestAiCredits = (data) => api.post('/ai/credits/request', data);
export const getMyAiCreditRequests = (params) => api.get('/ai/credits/requests', { params });
export const cancelAiCreditRequest = (id) => api.delete(`/ai/credits/requests/${id}`);

// Admin platform key
export const getAdminAiPlatformKey = () => api.get('/admin/ai/platform-key');
export const createAdminAiPlatformKey = (data) => api.post('/admin/ai/platform-key', data);
export const deleteAdminAiPlatformKey = (provider) =>
  api.delete(`/admin/ai/platform-key/${provider}`);

// Admin pricing
export const getAdminAiPricing = () => api.get('/admin/ai/pricing');
export const updateAdminAiPricing = (data) => api.put('/admin/ai/pricing', data);

// Admin model pricing
export const getAdminAiModelPricing = () => api.get('/admin/ai/model-pricing');
export const deleteAdminAiModelPricing = (model) =>
  api.delete(`/admin/ai/model-pricing/${encodeURIComponent(model)}`);
export const createAdminAiModelPricing = (data) => api.post('/admin/ai/model-pricing', data);
export const updateAdminAiModelPricing = (model, data) =>
  api.put(`/admin/ai/model-pricing/${encodeURIComponent(model)}`, data);

// Admin company credits
export const getAdminAiOverview = (params) => api.get('/admin/ai/overview', { params });
export const addAdminAiCompanyCredits = (companyId, data) =>
  api.post(`/admin/ai/companies/${companyId}/add-credits`, data);

// Admin credit requests
export const getAdminAiCreditRequests = (params) =>
  api.get('/admin/ai/credit-requests', { params });
export const approveAdminAiCreditRequest = (id, data) =>
  api.post(`/admin/ai/credit-requests/${id}/approve`, data);
export const rejectAdminAiCreditRequest = (id, data) =>
  api.post(`/admin/ai/credit-requests/${id}/reject`, data);
export const reverseAdminAiCreditRequest = (id) =>
  api.post(`/admin/ai/credit-requests/${id}/reverse`);

// Admin metrics
export const getAdminAiMetrics = (params) => api.get('/admin/ai/metrics', { params });
export const getAdminAiUsage = (params) => api.get('/admin/ai/usage', { params });
export const getAiCreditMetrics = (params) => api.get('/ai/credits/metrics', { params });
